import { useGateValue } from "@statsig/react-bindings";

export const useEnableEmailChannelSelfOnboarding = (): boolean => {
  return useGateValue("enable_edm_seld_onboarding");
};
